// 根据链接拆分获取对应结构
const ROUTER_LINK_PARAMS = {
    'zuowenzhitiao://discover/subjectDetail': {
        text: '专题',
        type: 'subject',
        routeType: 1,
        params: {
            subjectId: {
                text: '专题ID',
                val: null,
                isValidate: true,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://studyPlan/detail': {
        text: '计划包',
        type: 'subject',
        routeType: 31,
        params: {
            planId: {
                text: '计划包ID',
                val: null,
                isValidate: true,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://discover/folderDetail': {
        text: '纸条夹',
        type: 'folder',
        routeType: 2,
        params: {
            folderId: {
                text: '纸条夹ID',
                val: null,
                isValidate: true,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://user/userCenter': {
        text: '个人中心',
        type: 'user',
        routeType: 3,
        params: null,
    },
    'zuowenzhitiao://note/shortNoteDetail': {
        text: '短纸条',
        type: 'short',
        routeType: 4,
        params: {
            noteId: {
                text: '短纸条ID',
                val: null,
                isValidate: true,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://note/longArticleDetail': {
        text: '长纸条',
        type: 'long',
        routeType: 5,
        params: {
            noteId: {
                text: '长纸条ID',
                val: null,
                isValidate: true,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://user/avatarBorder': {
        text: '头像挂饰',
        router: 'zuowenzhitiao://user/avatarBorder',
        type: 'avatar',
        params: null,
        routeType: 7,
    },
    'zuowenzhitiao://user/userMainPage': {
        text: '个人主页',
        type: 'userMain',
        routeType: 8,
        params: {
            userId: {
                text: '用户ID',
                val: '',
                ignore: true,
                isValidate: true,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://user/myProfile': {
        text: '资料管理',
        type: 'profile',
        params: null,
        routeType: 9,
    },
    'zuowenzhitiao://note/paragraphDetail': {
        text: '作品',
        type: 'paragraph',
        routeType: 10,
        params: {
            paragraphId: {
                text: '作品ID',
                val: null,
                isValidate: true,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://main/postPaper': {
        text: '投稿活动',
        type: 'postPaper',
        params: null,
        routeType: 11,
    },
    'zuowenzhitiao://note/collectionCenter': {
        text: '合集广场',
        type: 'collection',
        params: null,
        routeType: 12,
    },
    'zuowenzhitiao://main/mainPage': {
        text: '发现界面',
        type: 'mainPage',
        params: {
            tabIndex: {
                text: '主页tab(1关注页，2推荐页)',
                val: null,
                type: 'number',
            },
        },
        routeType: 13,
    },
    'zuowenzhitiao://note/article': {
        text: '首页',
        type: 'article',
        params: null,
        routeType: 14,
    },
    'zuowenzhitiao://user/honorCenter': {
        text: '称号管理',
        type: 'honorCenter',
        params: null,
        routeType: 15,
    },
    'zuowenzhitiao://note/marketCenter': {
        text: '小卖部',
        type: 'marketCenter',
        params: null,
        routeType: 16,
    },
    'zuowenzhitiao://note/circleDetail': {
        text: '圈子',
        type: 'circleDetail',
        routeType: 17,
        params: {
            circleId: {
                text: '圈子ID',
                val: null,
                isValidate: true,
                type: 'number',
            },
            tabIndex: {
                text: 'TAB ID(1新鲜发布,2最近回复,3热门)',
                val: null,
                type: 'number',
            },
        },
    },
    'zuowenzhitiao://user/giftList': {
        text: '礼包',
        type: 'giftList',
        params: null,
        routeType: 18,
    },
    'zuowenzhitiao://composition/all': {
        text: '作文素材页',
        type: 'all',
        params: null,
        routeType: 20,
    },
    'zuowenzhitiao://composition/shortSentence': {
        text: '作文素材-经典短句页',
        type: 'shortSentence',
        params: null,
        routeType: 21,
    },
    'zuowenzhitiao://composition/currentEvent': {
        text: '作文素材-时事页',
        type: 'currentEvent',
        params: null,
        routeType: 22,
    },
    'zuowenzhitiao://composition/person': {
        text: '作文素材-人物页',
        type: 'person',
        params: null,
        routeType: 23,
    },
    'zuowenzhitiao://composition/television': {
        text: '作文素材-名著影视页',
        type: 'television',
        params: null,
        routeType: 24,
    },
    'zuowenzhitiao://composition/excellentWorks': {
        text: '优秀作品页',
        type: 'excellentWorks',
        params: null,
        routeType: 25,
    },
    'zuowenzhitiao://composition/methodLearning': {
        text: '技法学习页',
        type: 'methodLearning',
        params: null,
        routeType: 26,
    },
    'zuowenzhitiao://composition/realQuestion': {
        text: '真题解析页',
        type: 'realQuestion',
        params: null,
        routeType: 27,
    },
    'zuowenzhitiao://note/dailyRecommend': {
        text: '每日计划页',
        type: 'dailyRecommend',
        params: null,
        routeType: 28,
    },
    'zuowenzhitiao://main/channel': {
        text: '所有的频道页面',
        type: 'channel',
        params: {
            channelId: {
                text: '频道ID',
                val: null,
                type: 'number',
            },
        },
        routeType: 29,
    },
    'zuowenzhitiao://main/xiaoetongWebView': {
        text: '小鹅通',
        type: 'xiaoetong',
        params: {
            url: {
                text: '链接地址',
                val: null,
            },
        },
        routeType: 30,
    },
    'zuowenzhitiao://user/openVipMember': {
        text: '会员开通页',
        type: 'member',
        params: null,
        routeType: 31,
    },
    'zuowenzhitiao://composition/questionAndEssay': {
        text: '题库范文页路由',
        type: 'questionAndEssay',
        params: null,
        routeType: 32,
    },
    'zuowenzhitiao://main/webView': {
        text: '网页链接',
        type: 'webView',
        routeType: 19,
        params: {
            url: {
                text: '链接地址',
                val: null,
            },
        },
    },
};
export default ROUTER_LINK_PARAMS;
